import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { map, Observable, startWith } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { CommonHelperComponent } from "../../common-helper/common-helper.component";
import { Router } from "@angular/router";

@Component({
  selector: "app-admin-mapping",
  templateUrl: "./admin-mapping.component.html",
  styleUrls: ["./admin-mapping.component.css"],
})
export class AdminMappingComponent implements OnInit {
  adminToken: any;
  mappings: FormGroup;
  trucksList: any;
  driverList: any;
  truckControl: FormControl;
  driverControl: FormControl;
  filteredTrucks: Observable<any[]>;
  filteredDriver: Observable<any[]>;
  mappingList: any;
  selectedTruck: any = null;
  // Selected driver variable
  selectedDriver: any = null;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  searchTruckNumber: any = -1;
  perPage: any = 10;
  loading: boolean = false;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  search_Number: any;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private adminService: AdminService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.mappings = new FormGroup({
      driver_id: new FormControl("", Validators.required),
      truck_id: new FormControl("", Validators.required),
    });
  }

  ngOnInit(): void {
    this.loadFormGroup();
    this.getMappingList(this.searchTruckNumber);
    this.getTrucksList();
    this.getDriverList();
    this.pagination(1);
    this.truckControl = new FormControl();
    this.driverControl = new FormControl();

    let triptype = "mapping";
    localStorage.setItem("tripType", triptype);

    this.driverControl.valueChanges.subscribe((inputValue) => {
      // If the input field is cleared, reset the selected driver
      if (!inputValue) {
        this.selectedDriver = null;
      }
    });
    this.truckControl.valueChanges.subscribe((inputValue) => {
      // If the input field is cleared, reset the selected driver
      if (!inputValue) {
        this.selectedTruck = null;
      }
    });
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (this.previousValue.length > previousLength && this.clear_btn) {
      this.callApi();
      this.search_btn = true;
      this.clear_btn = false;
    }

    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
    }

    if (value.length > 10) {
      input.value = value.substring(0, 10);
      this.snackBar.open("Registration Number Limit Exceeded", "Fail", {
        duration: 5000,
      });
    }

    if (value.length === 0) {
      this.resetMappingList();
    }
  }

  private callApi() {
    this.searchTruckNumber = "";
    this.fetch_page = 0;
    this.pagination(1);
    this.getMappingList(this.searchTruckNumber);
  }

  getMappingList(type: any) {
    this.searchTruckNumber = type;
    this.adminToken = localStorage.getItem("adminToken");
    this.loading = true;
    this.adminService
      .GetMappingsList(
        this.adminToken,
        this.searchTruckNumber,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (list: any) => {
          this.loading = false;
          this.mappingList = list.body.data;
          this.document_array.push(list.body.meta);
          this.last_page = list.body.meta.lastPage;
          this.getTrucksList();
          this.getDriverList();
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  // filterDrivers(value: any) {
  //   const filterValue = value.toLowerCase();

  //   return this.driverList.filter((option: any) =>
  //     option.toLowerCase().includes(filterValue)
  //   );
  // }

  loadFormGroup() {
    this.mappings = this.formBuilder.group({
      truck_id: ["", [Validators.required]],
      driver_id: ["", [Validators.required]],
    });
  }

  getTrucksList() {
    this.adminToken = localStorage.getItem("adminToken");
    this.adminService.GetAvailableTrucks(this.adminToken).subscribe(
      (result) => {
        if (result.status == 200) {
          this.trucksList = result.body.data;
          this.filteredTrucks = this.truckControl.valueChanges.pipe(
            startWith(""),
            map((state) => this.filterTrucks(state || ""))
          );
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  filterTrucks(searchText: string): any[] {
    const lowerCaseSearchText =
      typeof searchText === "string" ? searchText.toLowerCase() : "";
    return this.trucksList?.filter((truck: any) =>
      truck.truck_number.toLowerCase().includes(lowerCaseSearchText)
    );
  }

  getDriverList() {
    this.adminToken = localStorage.getItem("adminToken") || "";
    this.adminService.GetAvailableDrivers(this.adminToken).subscribe(
      (result) => {
        if (result.status === 200) {
          // Filter available drivers
          this.driverList = result.body.data.filter(
            (item: any) => item.username && item.driver_status === "available"
          );
          this.filteredDriver = this.driverControl.valueChanges.pipe(
            startWith(""),
            map((state) => this.filterDrivers(state || ""))
          );
        }
      },
      (error) => {
        const errorMessage = error.error.message;
        if (
          ["jwt malformed", "jwt expired", "invalid signature"].includes(
            errorMessage
          )
        ) {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(errorMessage, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  filterDrivers(searchText: string): any[] {
    const lowerCaseSearchText =
      typeof searchText === "string" ? searchText.toLowerCase() : "";
    return this.driverList?.filter((driver: any) =>
      driver.username.toLowerCase().includes(lowerCaseSearchText)
    );
  }

  selectTruck(event: any) {
    this.selectedTruck = event;
    this.truckControl.setValue(event.truck_number);
  }

  selectDriver(option: any) {
    this.selectedDriver = option; // Assign selected driver
    this.driverControl.setValue(option.username);
  }

  addMappings(event: any) {
    if (
      this.selectedTruck?._id === undefined ||
      this.selectedDriver?._id === null
    ) {
      this.snackBar.open("Please select truck", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (
      this.selectedDriver?._id === undefined ||
      this.selectedDriver?._id === null
    ) {
      this.snackBar.open("Please select driver", "Fail", {
        duration: 3000,
      });
      return;
    }
    this.adminToken = localStorage.getItem("adminToken");
    const mappingData = {
      truck_id: this.selectedTruck._id,
      driver_id: this.selectedDriver._id,
    };
    this.adminService.AddMappings(this.adminToken, mappingData).subscribe(
      (response) => {
        if (response.status == 200) {
          this.getMappingList(this.searchTruckNumber);
          this.mappings.reset();
          this.mappings.clearValidators();
          // Reset the truckControl to clear the input
          this.truckControl.reset();
          this.driverControl.reset();
        }
        {
          this.snackBar.open("Mapping Added successfully", "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  deleteMapping(mappingData: any) {
    this.adminToken = localStorage.getItem("adminToken");
    const dialogRef = this.dialog.open(CommonHelperComponent, {
      data: { message: "Are you sure want to delete this mapping." },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res == "yes") {
        this.loading = false;
        this.adminService
          .DeleteMappings(this.adminToken, mappingData._id)
          .subscribe(
            (response: any) => {
              if (response.status == 200) {
                this.searchTruckNumber = -1;
                this.search_Number = "";
                this.clear_btn = false;
                this.search_btn = true;
                this.getMappingList(this.searchTruckNumber);
                this.getTrucksList();
                this.getDriverList();
                this.snackBar.open(response.body.message, "Success", {
                  duration: 5000,
                });
              }
            },
            (error) => {
              if (error.error.message === "jwt malformed") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "jwt expired") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "invalid signature") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              this.snackBar.open(error.error.message, "Fail", {
                duration: 5000,
              });
            }
          );
      }
    });
  }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.getMappingList(this.searchTruckNumber);
  }

  search(type: string) {
    if (type == "") {
      this.searchTruckNumber = "";
      this.fetch_page = 0;
      this.pagination(1);
      this.getMappingList(this.searchTruckNumber);
    } else {
      this.search_btn = false;
      this.clear_btn = true;
      this.startPage = 1;
      this.getMappingList(type);
    }
  }

  resetMappingList() {
    this.search_Number = "";
    this.clear_btn = false;
    this.search_btn = true;
    this.searchTruckNumber = -1;
    this.getMappingList(this.searchTruckNumber);
  }
}
